module.exports = __webpack_public_path__ + "img/crocus@2x.72bdc664.png";